import React from "react";
import TheHeader from "../components/global/TheHeader";
import TheFooter from "../components/global/TheFooter";
import { Outlet } from "react-router-dom";
import NavbarMobile from "../components/NavbarMobile";
import ContactGlobalIcon from "../components/ContactGlobalIcon";
const ThePublicLayout = () => {
  return (
    <div className="root-container">
      <div className="c-wrapper container">
        <TheHeader />
      </div>
      <Outlet />
      <div className="c-wrapper-overload-footer">
        <div className="c-wrapper container">
          <div className="wrapper"></div>
          <TheFooter />
        </div>
      </div>
      <NavbarMobile />
      <ContactGlobalIcon />
    </div>
  );
};

export default ThePublicLayout;
